































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import IfEmptyTextPrintNA from '../IfEmptyTextPrintNA.vue';
import { posturasMedicoesPressaoStrings, periodosMedicoesPressaoStrings } from '../../utils/constants';
import { MedicaoPressaoArterial } from '../../../../back/src/entity/MedicaoPressaoArterial';

export default Vue.extend({
  name: 'MedicaoPressaoArterialDados',
  components: {
    IfEmptyTextPrintNA,
  },
  props: {
    medicaoPressaoArterial: {
      type: Object as () => MedicaoPressaoArterial,
    },
  },
  data() {
    return {
      posturasMedicoesPressaoStrings,
      periodosMedicoesPressaoStrings,
    };
  },
  computed: {
    medicaoPressaoArterialData(): string {
      const momentDate = moment(this.medicaoPressaoArterial.data_medicao).utc();
      if (momentDate.isValid()) {
        return momentDate.format('DD/MM/YYYY');
      }
      return '';
    },
    periodoString(): string {
      return this.periodosMedicoesPressaoStrings[
        this.medicaoPressaoArterial.periodo
      ];
    },
    posturaString() {
      return this.posturasMedicoesPressaoStrings[
        this.medicaoPressaoArterial.postura
      ];
    },
    vRowClass(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex flex-column';
      }
      return '';
    },
  },
});
